import { render, staticRenderFns } from "./the-navbar.vue?vue&type=template&id=1a8b20c5&"
import script from "./the-navbar.vue?vue&type=script&lang=js&"
export * from "./the-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports